import React from "react";
import ClassificacaoJogadores from "./ClassificacaoJogadores";

const ClassificacaoJogadoresView = () => <ClassificacaoJogadores admin={false} />;

export default ClassificacaoJogadoresView;
